import React from 'react';
import Select from 'react-select';
export const deviceList = [
  {
    label: 'اندروید',
    value: 'android',
  },
  {
    label: 'iOS',
    value: 'ios',
  },
  {
    label: 'دسکتاپ',
    value: 'desktop',
  },
  {
    label: 'PWA',
    value: 'pwa',
  },
];

const SelectDevices = React.memo((props) => {
  let { devices, isDisabled } = props;
  isDisabled === undefined && (isDisabled = false);
  
  const handleSelectDevice = (option) => {
    props.onChange(option);
  };
  return (
    <Select
      options={deviceList}
      isMulti={true}
      isSearchable={true}
      placeholder="انتخاب دیوایس"
      value={!!devices?devices:[]}
      onChange={(option) => handleSelectDevice(option)}
      noOptionsMessage={() => 'یافت نشد'}
      isDisabled={isDisabled}
    />
  );
});

export default SelectDevices;
